import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $urlClearCache = '/admin/utilities/actions/clearCache';
const $urlCreateWeChatMenus = '/admin/utilities/actions/createWeChatMenus';
const $urlSyncDatabase = '/admin/utilities/actions/syncDatabase';

interface ICreateWeChatMenusResult {
  success: boolean;
  errorMessage: string;
}

export default {
  clearCache(success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlClearCache)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  createWeChatMenus(success: (res: ICreateWeChatMenusResult) => void) {
    utils.loading(true);
    request
      .post($urlCreateWeChatMenus)
      .then((response: AxiosResponse<ICreateWeChatMenusResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  syncDatabase(success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlSyncDatabase)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
